module.exports = __webpack_public_path__ + "img/logo.a3b6abf7.jpg";